import React, { useState } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

export default function AddPersonalAccount({ onBack }) {
  const [form, setForm] = useState({
    broker: "",
    size: "",
    currency: "$",
    maxDailyDD: "",
    currentPnL: "0"
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const saveAccount = async () => {
    if (!auth.currentUser) return alert("Not logged in");
    if (!form.broker || !form.size) return alert("Broker and Account Size are required");

    try {
      await addDoc(
        collection(db, "users", auth.currentUser.uid, "accounts"),
        {
          accountType: "personal",
          name: form.broker,
          size: Number(form.size),
          currency: form.currency,
          maxDailyDD: Number(form.maxDailyDD),
          maxTotalDD: Number(form.maxDailyDD), // Personal accounts usually use same DD for daily/total
          currentPnL: Number(form.currentPnL),
          phase: "Personal",
          createdAt: new Date()
        }
      );

      alert("Personal account added successfully!");
      if (onBack) onBack(); 
    } catch (error) {
      console.error("Error adding personal account: ", error);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h2 style={styles.title}>Personal Trading Account</h2>
        <p style={styles.subtitle}>
          Your own capital account (broker or exchange).
        </p>
      </header>

      <div style={styles.card}>
        <div style={styles.formGrid}>
          {/* Broker / Exchange */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>BROKER / EXCHANGE *</label>
            <input
              style={styles.input}
              name="broker"
              value={form.broker}
              onChange={handleChange}
              placeholder="Zerodha, Delta Exchange, Binance"
            />
          </div>

          {/* Account Size */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>ACCOUNT SIZE *</label>
            <input
              style={styles.input}
              name="size"
              type="number"
              value={form.size}
              onChange={handleChange}
              placeholder="100000"
            />
          </div>

          {/* Currency */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>CURRENCY *</label>
            <select
              style={styles.select}
              name="currency"
              value={form.currency}
              onChange={handleChange}
            >
              <option value="$">USD ($)</option>
              <option value="₹">INR (₹)</option>
            </select>
          </div>

          {/* Risk Limit */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>DAILY RISK LIMIT (%) *</label>
            <input
              style={styles.input}
              name="maxDailyDD"
              type="number"
              value={form.maxDailyDD}
              onChange={handleChange}
              placeholder="2"
            />
          </div>

          {/* Current PnL */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>CURRENT PNL</label>
            <input
              style={styles.input}
              name="currentPnL"
              type="number"
              value={form.currentPnL}
              onChange={handleChange}
              placeholder="0"
            />
          </div>
        </div>

        <button style={styles.button} onClick={saveAccount}>
          Save Personal Account
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { 
    maxWidth: "600px", 
    margin: "0 auto", 
    padding: "20px", 
    color: "#fff" 
  },
  header: { marginBottom: "24px" },
  title: { 
    fontSize: "24px", 
    fontWeight: "600", 
    color: "#fff", 
    marginBottom: "4px" 
  },
  subtitle: { fontSize: "14px", color: "#9ca3af" },
  card: {
    backgroundColor: "rgba(13, 17, 23, 0.4)", // Matches your Log Trade form
    border: "1px solid #1e293b",
    borderRadius: "12px",
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  formGrid: { display: "flex", flexDirection: "column", gap: "18px" },
  inputGroup: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { 
    fontSize: "11px", 
    fontWeight: "700", 
    color: "#4b5563", 
    letterSpacing: "0.05em" 
  },
  input: {
    background: "#0d1117",
    border: "1px solid #30363d",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#fff",
    fontSize: "14px",
    outline: "none",
  },
  select: {
    background: "#0d1117",
    border: "1px solid #30363d",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    outline: "none",
  },
  button: {
    background: "#0ea5e9", // Cyan button to match branding
    color: "#000",
    fontWeight: "700",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "15px",
    marginTop: "10px",
  }
};